const IntellectualCapabilityExtendedIcons = {
    abstractAbility: 'brain',
    numericalAbility: 'calculator',
    verbalAbility: 'pen-fancy'
};

export default IntellectualCapabilityExtendedIcons;
